import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './meeting-folder.types';
import * as constants from './meeting-folder.constants';

export const meetingFoldersReducer = generateResourceReducer<types.IMeetingFolder>({
  STORE: constants.STORE_MEETING_FOLDER,
  CLEAR: constants.CLEAR_MEETING_FOLDER,
});
